import { useEffect, useState } from 'react';

import { GET_PDP_CMS_PAGE } from '../../../../shared/graphql/product-detail-queries';

import { useQuery } from '../../../../shared/hooks/hooks';

import { getCmsComponentsInSlots } from '../../../../shared/utils/cms/cms';
import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

export function usePDPCMSContent(cmsPageId) {
  const [overviewHeading, setOverviewHeading] = useState('');
  const [servicesHeading, setServicesHeading] = useState('');
  const [services, setServices] = useState([]);
  const [tooltips, setTooltips] = useState({});
  const [vovLinkLabel, setVOVLinkLabel] = useState('');
  const [hasPDPCMSContentloaded, setHasPDPCMSContentloaded] = useState(false);

  const { data, isLoading } = useQuery(GET_PDP_CMS_PAGE, {
    skip: !cmsPageId,
    variables: {
      id: cmsPageId
    }
  });

  const { contentSlots, documentTitle, metaTags } = data?.cms?.page || {};

  useEffect(() => {
    if (!isLoading) {
      if (isArrayWithLength(contentSlots)) {
        let overviewHeading = '';
        let servicesHeading = '';
        let services = [];
        let tooltips = {};
        let vovLinkLabel = '';

        getCmsComponentsInSlots(contentSlots, cmsComponent => {
          const { name } = cmsComponent || {};

          if (name === 'ProductOverviewHeading') {
            overviewHeading = cmsComponent.html;
          } else if (name == 'Wheel-VOV-Link') {
            vovLinkLabel = cmsComponent.html;
          } else if (
            name === 'TireTooltips' &&
            isArrayWithLength(cmsComponent.tooltips)
          ) {
            tooltips = cmsComponent.tooltips.reduce((acc, t) => {
              if (t && t.id && t.tipText) {
                acc[t.id] = t.tipText;
              }
              return acc;
            }, {});
          } else if (
            name === 'FreeTireServices' &&
            isArrayWithLength(cmsComponent.services)
          ) {
            servicesHeading = cmsComponent.heading;
            services = cmsComponent.services;
          }
        });

        setOverviewHeading(overviewHeading);
        setServicesHeading(servicesHeading);
        setServices(services);
        setTooltips(tooltips);
        setVOVLinkLabel(vovLinkLabel);
      }
      setHasPDPCMSContentloaded(true);
    }
  }, [isLoading, contentSlots]);

  return {
    documentTitle,
    hasPDPCMSContentloaded,
    metaTags,
    overviewHeading,
    services,
    servicesHeading,
    tooltips,
    vovLinkLabel
  };
}
